"use client";

import type { Fieldset as FieldsetPrimitive } from "@base-ui/react/fieldset";
import { type TenantContextValue, useTenant } from "@tillix/tenants/react";
import { baseFieldsetKit } from "./fieldset";
import { conEdisonFieldsetKit } from "./fieldset.con-edison";
import type { OptionalTenantProp } from "../../../types";

export interface FieldsetParts {
  Root: React.FC<FieldsetPrimitive.Root.Props>;
  Legend: React.FC<FieldsetPrimitive.Legend.Props>;
}

function useFieldsetKit(tenantProp?: TenantContextValue) {
  const contextTenant = useTenant();
  const tenantRefId = tenantProp?.id ?? contextTenant?.id;

  switch (tenantRefId) {
    case "con-edison":
      return conEdisonFieldsetKit;
    default:
      return baseFieldsetKit;
  }
}

function makeFieldsetPart<P extends object>(
  pick: (kit: FieldsetParts) => React.FC<P>,
) {
  return function FieldsetPart(props: P & OptionalTenantProp) {
    const { tenant, ...rest } = props;
    const Kit = useFieldsetKit(tenant);
    const Comp = pick(Kit);
    return <Comp {...(rest as P)} />;
  };
}

export const Fieldset = makeFieldsetPart<FieldsetPrimitive.Root.Props>(
  (k) => k.Root,
) as React.FC<FieldsetPrimitive.Root.Props> & {
  Legend: React.FC<FieldsetPrimitive.Legend.Props>;
};

Fieldset.Legend = makeFieldsetPart<FieldsetPrimitive.Legend.Props>(
  (k) => k.Legend,
);
